import {
    SET_ATTENTION_TEXT,
    SET_ERROR_TEXT,
    SET_WARNING_TEXT,
    SET_EXTERNAL_LINK_TEXT,
    SET_ERROR_LOGIN_USER_TEXT,
    SET_COMMON_TEXTS,
} from './constants'

const initialState = {
    attention: '',
    error: '',
    warning: '',
    externalLink: '',
    errorLoginUser: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_ATTENTION_TEXT: {
            return {
                ...state,
                attention: action.payload,
            }
        }

        case SET_ERROR_TEXT: {
            return {
                ...state,
                error: action.payload,
            }
        }

        case SET_WARNING_TEXT: {
            return {
                ...state,
                warning: action.payload,
            }
        }

        case SET_EXTERNAL_LINK_TEXT: {
            return {
                ...state,
                externalLink: action.payload,
            }
        }

        case SET_ERROR_LOGIN_USER_TEXT: {
            return {
                ...state,
                errorLoginUser: action.payload,
            }
        }

        case SET_COMMON_TEXTS: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/CommonTexts/data/reducer.js